import React from 'react';
import { SvgProps } from 'models/Icon';

export default (props: SvgProps) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fillRule="evenodd"
    clipRule="evenodd"
    fill="#173C3B"
    {...props}
  >
    <path d="M1 17L9.5 10.5L14.5 15L18.5 12L23 14.5V21H1V17Z" fill="#F1E4D0" />
    <path d="M21 3H3C1.89543 3 1 3.89543 1 5V19C1 20.1046 1.89543 21 3 21H21C22.1046 21 23 20.1046 23 19V5C23 3.89543 22.1046 3 21 3ZM3 2C1.34315 2 0 3.34315 0 5V19C0 20.6569 1.34315 22 3 22H21C22.6569 22 24 20.6569 24 19V5C24 3.34315 22.6569 2 21 2H3Z" />
    <path d="M19 6.5C19 7.32843 18.3284 8 17.5 8C16.6716 8 16 7.32843 16 6.5C16 5.67157 16.6716 5 17.5 5C18.3284 5 19 5.67157 19 6.5Z" />
    <path d="M10.8721 12.0618C9.9844 11.3127 8.5156 11.3127 7.6279 12.0618L1.32244 17.3821C1.11139 17.5602 0.795938 17.5335 0.617859 17.3224C0.43978 17.1114 0.466508 16.7959 0.677559 16.6179L6.98301 11.2975C8.2432 10.2342 10.2568 10.2342 11.517 11.2975L14.75 14.0254L16.608 12.4577C17.8682 11.3944 19.8818 11.3944 21.142 12.4577L23.3224 14.2975C23.5335 14.4756 23.5602 14.791 23.3821 15.0021C23.2041 15.2131 22.8886 15.2398 22.6776 15.0618L20.4971 13.222C19.6094 12.4729 18.1406 12.4729 17.2529 13.222L15.5253 14.6796L17.8224 16.6179C18.0335 16.7959 18.0602 17.1114 17.8821 17.3224C17.7041 17.5335 17.3886 17.5602 17.1776 17.3821L14.4348 15.0679C14.4302 15.0642 14.4257 15.0603 14.4212 15.0564L10.8721 12.0618Z" />
  </svg>
);
